/**
 * @generated SignedSource<<09ec3615b159c1f0868a6357f2ab5bda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutinesListItemSchedule_schedule$data = {
  readonly __typename: "RoutineScheduleDaily";
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemScheduleDaily_schedule">;
  readonly " $fragmentType": "WorkspaceRoutinesListItemSchedule_schedule";
} | {
  readonly __typename: "RoutineScheduleMonthly";
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemScheduleMonthly_schedule">;
  readonly " $fragmentType": "WorkspaceRoutinesListItemSchedule_schedule";
} | {
  readonly __typename: "RoutineScheduleWeekly";
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemScheduleWeekly_schedule">;
  readonly " $fragmentType": "WorkspaceRoutinesListItemSchedule_schedule";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "WorkspaceRoutinesListItemSchedule_schedule";
};
export type WorkspaceRoutinesListItemSchedule_schedule$key = {
  readonly " $data"?: WorkspaceRoutinesListItemSchedule_schedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemSchedule_schedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutinesListItemSchedule_schedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutinesListItemScheduleDaily_schedule"
        }
      ],
      "type": "RoutineScheduleDaily",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutinesListItemScheduleMonthly_schedule"
        }
      ],
      "type": "RoutineScheduleMonthly",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutinesListItemScheduleWeekly_schedule"
        }
      ],
      "type": "RoutineScheduleWeekly",
      "abstractKey": null
    }
  ],
  "type": "RoutineSchedule",
  "abstractKey": "__isRoutineSchedule"
};

(node as any).hash = "56db5f8e8c762b32715480889873cceb";

export default node;
